export { default as AppData } from './appData';


// WEBPACK FOOTER //
// ./src/services/index.js